export default "__VITE_ASSET__fZbkdj0C__"